import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CTABand = ({
  kicker = "Partnerships",
  title = "Build the Bridge With Us",
  copy = "Atlantic Bridge works with universities, newsrooms, foundations, cultural institutions, governments, civil-society organizations and responsible private-sector partners while preserving editorial independence and transparency.",
  buttonLabel = "Explore Partnerships",
  to = "/contact",
}) => (
  <section data-testid="cta-band" className="grain bg-atlantic py-20 lg:py-24">
    <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-8">
      <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold">{kicker}</p>
      <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-white sm:text-4xl">{title}</h2>
      <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/70">{copy}</p>
      <Link
        data-testid="cta-band-button"
        to={to}
        className="group mt-9 inline-flex items-center gap-2 bg-gold px-8 py-4 text-sm font-semibold tracking-wide text-atlantic transition-colors hover:bg-gold-light"
      >
        {buttonLabel}
        <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
      </Link>
    </div>
  </section>
);
